"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftMetadataAttributeToJSON = exports.NftMetadataAttributeFromJSONTyped = exports.NftMetadataAttributeFromJSON = void 0;
function NftMetadataAttributeFromJSON(json) {
    return NftMetadataAttributeFromJSONTyped(json, false);
}
exports.NftMetadataAttributeFromJSON = NftMetadataAttributeFromJSON;
function NftMetadataAttributeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'trait_type': json['trait_type'],
        'value': json['value'],
    };
}
exports.NftMetadataAttributeFromJSONTyped = NftMetadataAttributeFromJSONTyped;
function NftMetadataAttributeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'trait_type': value.trait_type,
        'value': value.value,
    };
}
exports.NftMetadataAttributeToJSON = NftMetadataAttributeToJSON;
